
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/list-subheader",
      function () {
        return require("private-next-pages/material-ui/api/list-subheader.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/list-subheader"])
      });
    }
  